import type {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";
import router from "@/router";

export const onRequestFulFilled = (request: InternalAxiosRequestConfig) => {
  Object.assign(request.headers, computeHeaders());
  request.baseURL = import.meta.env.VITE_ROOT_API;

  return request;
};

const computeHeaders = () => {
  const authStore = useAuthStore();

  return {
    Authorization: authStore.isLoggedIn
      ? `Bearer ${authStore.token}`
      : undefined,
  };
};

export const onRequestRejected = (error: AxiosError) => error;
export const onResponseFulFilled = (response: AxiosResponse) => response;

export const onResponseRejected = (error: AxiosError) => {
  const authStore = useAuthStore();
  const appStore = useAppStore();

  const { response } = error;

  if (!response) return Promise.reject(error); // network error, not axios related

  const { status } = response;

  if (status === 401) {
    appStore.setCurrentLocation();
    authStore.clearToken();
    appStore.redirectUserToLogin();
  }

  if ([402, 403, 404, 500].includes(status)) {
    return router.replace({
      name: "error",
      params: {
        errorCode: status,
      },
    });
  }

  return Promise.reject(error);
};
